export default {
  COPYRIGHT: '© 2024 midtones.de',
  IMPRINT: 'Imprint',
  PRIVACY: 'Data Privacy',
};
